import { Trans, useLingui } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { observer } from "mobx-react-lite";

import { apiGetHfComorbiditiesByPatientIdOptions } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { AButton } from "../../../components/ui-kit/a-button";
import { PatientSubpage } from "../common/patient-subpage";
import { DiagnosesItem } from "./diagnoses";
import { DiagnosesTable } from "./diagnoses-table";

export const DiagnosesRoute = observer(function DiagnosesRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const api = props.app.seerlinqApi;

  const { data, isPending, refetch } = useQuery(
    apiGetHfComorbiditiesByPatientIdOptions({
      path: { patient_id: patient.patientId },
    }),
  );

  return (
    <PatientSubpage title={t`Comorbidities`} loading={isPending}>
      <DiagnosesTable
        filterActions={
          <AButton href="add" variant="primary">
            <Plus />
            <Trans>Add comorbidities</Trans>
          </AButton>
        }
        api={api}
        data={data?.diagnoses ?? noDiagnoses}
        onInvalidated={refetch}
        patient={patient}
        persistState
      />
    </PatientSubpage>
  );
});

const noDiagnoses: DiagnosesItem[] = [];
